import styled from "styled-components";
import {
  Card,
  CardActions,
  CardTitle,
  Modal,
  Checkbox,
} from "../../../Components";

const StyledModal = styled(Modal)<any>`
  && {
    top: 24px;
    max-height: 90vh;
    overflow: hidden;
  }
`;

const TermoBody = styled.div`
  max-height: 48vh;
  overflow-y: auto;
  margin: 8px 16px 0;
  padding: 4px 12px 12px;
  text-align: left;
  font-size: 14px;
  line-height: 1.45;
  color: #1a1a1a;
`;

const TermoTitulo = styled.h2`
  font-size: 16px;
  line-height: 1.35;
  margin: 8px 0 16px;
`;

const Secao = styled.h3`
  font-size: 15px;
  margin: 16px 0 8px;
`;

type TermosEditalModalProp = {
  isModalOpen: boolean;
  setModal: (modalOpen: boolean) => void;
  aceitarTermo: () => void;
};

export function TermosEditalModal({
  isModalOpen,
  setModal,
  aceitarTermo,
}: TermosEditalModalProp) {

  const accept = () => {
    setTimeout(() => {
      aceitarTermo();
      setModal(false);
    }, 1500);
  };

  return (
    <StyledModal isVisible={isModalOpen} outterClick={() => {}} size={"large"}>
      <Card>
        <CardTitle>Leia o Termo de Ciência (LGPD) e as informações do edital.</CardTitle>
        <TermoBody>
          <TermoTitulo>
            Termo de Ciência do(a) candidato(a) sobre o tratamento de dados pessoais e declaração de ciência e concordância com o edital do Processo Seletivo Unificado de Bolsas “Direito ao Futuro e Promais” – alunos(as) do 2º ao 5º ano – 2027
          </TermoTitulo>

          <Secao>I. Da ciência sobre o tratamento de dados pessoais</Secao>
          <p>
            Nos termos da Lei nº 13.709/2018 – Lei Geral de Proteção de Dados Pessoais (LGPD) e suas alterações, e em observância aos princípios da publicidade e da transparência que regem a Administração Pública, no âmbito do Processo Seletivo Unificado de Bolsas (Direito ao Futuro e Promais) para alunos(as) do 2º ao 5º ano (Ano Letivo 2027), declaro estar ciente de que:
          </p>
          <p>
            a) a Faculdade de Direito de São Bernardo do Campo – FDSBC, Autarquia Municipal, realizará o tratamento dos dados pessoais necessários à execução do processo seletivo, à análise da condição socioeconômica, à aplicação dos critérios de classificação e à eventual concessão da bolsa de estudo;
          </p>
          <p>
            b) poderão ser tratados dados pessoais relativos à identificação, à residência, à composição do grupo familiar, à renda, aos vínculos de trabalho e às informações fiscais, bem como dados pessoais sensíveis referentes à saúde e à origem racial ou étnica do(a) candidato(a) ou de integrantes de seu grupo familiar, pertinentes aos critérios previstos no Edital;
          </p>
          <p>
            c) considerando que se trata de execução de política pública de concessão de bolsas de estudo, o tratamento dos dados pessoais do(a) candidato(a) e demais integrantes do grupo familiar será realizado com dispensa de consentimento, com observância da LGPD, notadamente os arts. 7º, III, 11, II, “b”, e 23 da LGPD;
          </p>
          <p>
            d) os dados pessoais poderão ser acessados pelas unidades administrativas da FDSBC e compartilhados com entidades ou órgãos públicos, quando necessário e observadas as disposições legais aplicáveis;
          </p>
          <p>
            e) os dados serão mantidos pelo tempo necessário para cumprir com as finalidades para as quais foram coletados, bem como para o cumprimento de obrigações legais ou regulatórias, considerando-se também a eventual necessidade de utilização em processos judiciais, administrativos ou arbitrais;
          </p>
          <p>
            f) as informações complementares sobre o tratamento de dados pessoais e os canais para o exercício dos direitos previstos na LGPD estão disponíveis na Política de Privacidade da FDSBC, disponível em{" "}
            <a href="https://www.direitosbc.br/politica-de-privacidade-lgpd/" target="_blank" rel="noreferrer">
              https://www.direitosbc.br/politica-de-privacidade-lgpd/
            </a>.
          </p>

          <Secao>II. Dos dados dos(as) integrantes do grupo familiar</Secao>
          <p>
            Declaro ainda que, sob minha responsabilidade, estou autorizado(a) a fornecer à FDSBC as informações e os documentos relativos aos(às) integrantes do meu grupo familiar, inclusive aqueles que contenham dados pessoais e sensíveis, para as finalidades específicas deste Processo Seletivo Unificado de Bolsas, permanecendo assegurados aos(às) respectivos(as) titulares os direitos previstos na LGPD.
          </p>

          <Secao>III. Do aceite eletrônico e da concordância com o edital</Secao>
          <p>
            Ao selecionar a opção de aceite disponibilizada no sistema, declaro, para os fins cabíveis, que:
          </p>
          <p>
            a) li e compreendi o conteúdo deste Termo, estando ciente das informações nele apresentadas e das condições relativas ao tratamento dos dados pessoais fornecidos, inclusive dos dados sensíveis, quando aplicável, para as finalidades nele especificadas e em conformidade com a legislação vigente;
          </p>
          <p>
            b) estou ciente e de acordo com as disposições, os critérios e as condições estabelecidos no Edital do Processo Seletivo Unificado de Bolsas Direito ao Futuro e Promais – alunos(as) do 2º ao 5º ano – 2027, comprometendo-me a observá-los integralmente.
          </p>
        </TermoBody>
        <CardActions>
          <Checkbox
            label="Eu li e aceito o Termo de Ciência (LGPD) e os termos do edital."
            onClick={accept}
          />
        </CardActions>
      </Card>
    </StyledModal>
  );
}
